import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from '../Assets/png/game controller art.png';
import astronautImg from '../Assets/png/astrooff.png';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [, setIndex] = useState(1);
  const [animationComplete, setAnimationComplete] = useState(false); // Added state
  const toRotate = [ "Game Developer","Web Developer", "UI/UX Designer" ];
  const period = 1000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  },);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => 
                <div className={isVisible && !animationComplete ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>{`Hi! I'm Adnan`} </h1>
                  <h1><span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Web Developer", "Web Designer", "UI/UX Designer" ]'><span className="wrap">{text}</span></span></h1>
                  <p>Welcome to my digital domain! I'm Adnan Mohammed Shelim, a self-taught programmer with a passion for crafting exceptional digital experiences. My diverse skill set encompasses web development, game development, social media management, and digital marketing. As a dedicated enthusiast of all things tech, I've embarked on a journey to create innovative and engaging solutions that bring ideas to life. Explore my portfolio to discover a collection of projects that showcase my creative prowess and technical expertise. Whether you're seeking captivating websites, interactive games, or effective digital marketing strategies, you've come to the right place. Join me on this exciting digital adventure, and let's transform your ideas into reality.</p>
                  {/* <button onClick={() => console.log('connect')}><span class="lets">Let’s Connect</span><ArrowRightCircle size={25} /></button> */}
                </div>
              } 
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => {
                if (isVisible && !animationComplete) {
                  setAnimationComplete(true); // Set animationComplete to true when the component becomes visible
                }

                return (
                  <div className={animationComplete ? "animate__animated animate__zoomIn" : ""}>
                    <img className="astro" src={astronautImg} alt="astronaut Img"/>
                    <a href="https://crimsonjester.itch.io/"><img className="controller" src={headerImg} alt="Header Img"/></a>
                  </div>
                );
              }}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
